<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="margin-top:20px;"
      v-if="showEsignature"
    >
      <v-card
        :style="(getLocalSigning && !getAdoptSignature && formSubmissionAttempt) ? 'background:#ffffcc;' : ''"
      >
        <v-card-text>
          <div
            v-html="section.text"
          />
        </v-card-text>
        <div
          style="position:relative;display:flex;background: rgba(0,0,0,0.1);padding: 10px;"
        >
          <v-icon>
            mdi-signature
          </v-icon>
          &nbsp;&nbsp;
          <div
            v-if="getLocalSigning"
            style="display:inline-block;"
          >
            <div
              v-if="getAdoptSignature"
            >
              <img
                :src="getAdoptSignature"
                style="max-width: 100%;max-height: 100px;"
              /><br />
              <v-btn
                @click="signingDialog = true"
                flat
                dense
              >
                Edit
              </v-btn>
            </div>
            <div
              v-else
            >
              <v-btn
                @click="signingDialog = true"
                color="primary"
              >
                Click here to adopt &amp; sign
              </v-btn>
            </div>
          </div>
          <div
            v-else
            style="display:inline-block;"
          >
            <b>You will be requested to electronically sign this document after submission and review.</b>
          </div>
        </div>
      </v-card>
      <v-dialog
        v-model="signingDialog"
        width="600"
        persistent
      >
        <v-card>
          <v-card-text>
            <div
              style="padding-bottom: 25px;"
            >
              <div
                style="font-weight: 300;font-size: 24px;"
              >
                Adopt a Signature
              </div>
              <div
                style="font-size: 16px;"
              >
                To sign this document, use your cursor or finger to draw your signature in the box below. Click "Sign" when you're done.
              </div>
            </div>
            <v-card
              elevation="8"
              style="border: 1px solid rgba(26,26,26,1);"
            >
              <VueSignaturePad
                width="100%"
                height="200px"
                ref="signaturePad"
                :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
              />
          </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="signingDialog = false"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              @click="$refs.signaturePad.clearSignature()"
              flat
            >
              Clear
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click="saveSignature()"
            >
              Sign
            </v-btn>
          </v-card-actions>
          <div
            style="padding: 10px;background: rgba(0,0,0,0.05);font-size: 12px;"
          >
            By clicking "Sign", you consent to the use of electronic signatures and documents on {{ app_name }} . You acknowledge that your electronic signature is legally binding and has the same force and effect as your handwritten signature.<br /><br />
            If you do not wish to sign electronically, you have the right to cancel this process. To do so, please click "Cancel" and contact <span class="legalFoot"/> directly. They will provide you with alternative methods to complete and submit your forms.
          </div>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="requestLocation"
        width="400"
        persistent
      >
        <v-card
          style="text-align: center;"
        >
          <v-card-text>
            <div>
              <v-icon
                size="64"
              >
                mdi-crosshairs-question
              </v-icon>
            </div>
            <div>
              <h2>Please Grant Location Access</h2>
            </div>
            <div
              style="font-size: 16px;"
            >
              Your location is used to verify you are the one signing this form, and is attached to your signature.
            </div>
          </v-card-text>
          <v-progress-linear
            v-if="fetchingLocation"
            indeterminate
          />
          <v-card-actions
            style="background: rgba(0,0,0,0.1);"
          >
            <v-btn
              :disabled="fetchingLocation"
              flat
              small
              @click="declineLocation"
            >
              Decline
            </v-btn>
            <v-spacer />
            <v-btn
              :disabled="fetchingLocation"
              color="primary"
              small
              @click="grantLocation"
            >
              Grant
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-expand-transition>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'UserFormESignature',
  props: ['userFormId', 'section'],
  data () {
    return {
      infoDialog: false,
      signingDialog: false,
      requestLocation: false,
      fetchingLocation: false
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'getLocalSigning',
      'getAdoptSignature',
      'getUserLocation'
    ]),
    ...mapState('userform', [
      'formSubmissionAttempt'
    ]),
    showEsignature(){
      if(!this.section.conditional_question_id) return true
      var answer =  this.answer(this.section.conditional_question_id, this.section.conditional_fieldtype_id)
      if(answer && answer.string == this.section.conditional_value) return true
      return false
    }
  },
  methods: {
    ...mapMutations('userform', [
      'setAdoptSignature',
      'setLocation'
    ]),
    sectionElId (section) {
      return `section-${section.id}`
    },
    saveSignature () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      this.setAdoptSignature(data)
      this.signingDialog = false
      if (!this.getUserLocation)
        this.requestLocation = true
    },
    declineLocation() {
      this.requestLocation = false
    },
    grantLocation () {
      this.fetchingLocation = true
      navigator.geolocation.getCurrentPosition((position) => {
        var locationArr = {lat: position.coords.latitude, lon: position.coords.longitude}
        this.setLocation(locationArr)
        this.requestLocation = false
        this.fetchingLocation = false
      }, () => {
        this.setLocation({err: "User rejected or location not available on device"})
        this.requestLocation = false
        this.fetchingLocation = false
      })
    }
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>
